import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  ReviewDetailLevel,
  ReviewDetailModule,
  ReviewMentor,
} from "@/lib/api/training-simulator/training-simulator-review";
import { useSignedMedia } from "@/lib/hooks/use-signed-media";
import { formatJoinedDate } from "@/lib/training-simulator/utils";
import { getInitials } from "@/lib/utils";
import { IconButton } from "@somethings-ui/web";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { LevelInfo } from "../common/level-info";
import { MessageMentor } from "./message-mentor";
import { getModuleTheme } from "@/lib/training-simulator/module-theme";

export function TrainingReviewTopBar({
  level,
  mentor,
  joinedAt,
  module,
}: {
  level: ReviewDetailLevel;
  mentor: ReviewMentor;
  module: ReviewDetailModule;
  joinedAt: string | null;
}) {
  const { url } = useSignedMedia(mentor.profile_picture_url || "");
  const navigate = useNavigate();

  const levelWithModule = { ...level, module };

  const theme = getModuleTheme(module);

  return (
    <div className="flex flex-row items-center justify-between border-b-2 border-b-gray-200 bg-surfaces-z3 px-6 py-3">
      <div className="flex flex-row items-center">
        <IconButton
          variant="ghost-black"
          icon={<ArrowLeft className="size-5" />}
          onClick={() =>
            navigate({
              to: "/training/review",
            })
          }
        />

        <div className="ml-2 flex flex-row items-center gap-2">
          <Avatar className="size-8 rounded-md">
            <AvatarImage src={url || ""} />
            <AvatarFallback className="rounded-md bg-surfaces-z4 text-body-4 uppercase text-text-secondary">
              {getInitials(mentor.name)}
            </AvatarFallback>
          </Avatar>

          <div className="flex flex-col">
            <span className="text-body-3 text-text-primary">{mentor.name}</span>
            {joinedAt && (
              <span className="text-body-4 text-text-secondary">
                joined {formatJoinedDate(joinedAt)}
              </span>
            )}
          </div>

          <MessageMentor mentor={mentor} className="ml-6" />
        </div>
      </div>

      <LevelInfo
        level={levelWithModule}
        accentClassName={theme.headerClassName}
      />
    </div>
  );
}
